import {
  BoxGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  Scene,
  SphereGeometry,
} from "three";
import { extendShaderWithWorldGradient } from "../utils/shader_utils";
import BoxWithBottomOrigin from "../utils/box_bottom_origin";
import PoolBeach from "./pool_beach";
import AlignedBox from "../utils/aligned_box";

class PoolStairs {
  private stairsGroup: Group;
  private stepDepth: number;
  private poolBeach: PoolBeach;
  private color: number = 0xffffff;
  private isAngularStairs = false;
  private isSuspensionStairs = false;
  private isInEditMode = false;

  constructor(
    poolBeach: PoolBeach,
    private poolLength: number,
    private poolWidth: number,
    private poolDepth: number,

    private fixedWidth: boolean,
    private fixedWidthValue?: number
  ) {
    this.stairsGroup = new Group();
    this.poolBeach = poolBeach;
    this.createStairs();
  }

  private createStairs() {
    const stepWidth = this.fixedWidth
      ? this.fixedWidthValue || 1
      : this.poolWidth;

    const material = new MeshStandardMaterial({
      color: 0xffffff,
      metalness: 1.0,
      roughness: 1.0,
    });
    extendShaderWithWorldGradient(material, 0);

    let sideOffset = this.poolWidth / 2.0;


    sideOffset -= stepWidth / 2.0;

    this.stairsGroup.position.set(
      this.poolLength / 2.0 - this.poolBeach.fixedLength,
      -0.4,
      sideOffset
    );

    //  return;
    const totalHeight = this.poolDepth - 0.4;
    const numStairs = Math.ceil(this.poolDepth * 3);

    let heightStep = totalHeight / numStairs;
    heightStep = heightStep;

    const stepLength = 0.5;

    for (let i = 0; i < numStairs; i++) {
      const thisStepLength = stepLength + stepLength * i;

      const stair = AlignedBox.bottomCenter(
        this.isSuspensionStairs ? stepLength * 0.5 : thisStepLength,
        this.isSuspensionStairs ? heightStep * 0.5 : heightStep,
        this.isAngularStairs ? this.poolWidth*2.0 : stepWidth,
        material
      );

      if (this.isAngularStairs) {
       // stair.getMesh().translateX(stepLength );
       // stair.getMesh().translateZ(stepLength * 0.5);
        stair.getMesh().rotateY(-Math.PI / 4.0);
      }
      if (this.isSuspensionStairs)
        stair.getMesh().translateX(-stepLength * 0.5 * i - stepLength * 0.25);
      stair.getMesh().translateY(-i * heightStep);
      stair.getMesh().castShadow = true;
      stair.getMesh().receiveShadow = true;
      this.stairsGroup.add(stair.getMesh());
    }

   if (this.isAngularStairs) {
      this.stairsGroup.translateX(stepLength * 0.25);
      this.stairsGroup.translateZ(stepLength * 0.5);
    }

    // this.stairsGroup.rotateY(Math.PI/4.0);

    // this.stairsGroup.add(pointMesh);
  }

  addToScene(scene: Scene) {
    scene.add(this.stairsGroup);
  }

  updateColor(newColor?: number) {
    if (newColor != null) this.color = newColor;
    const material = new MeshStandardMaterial({
      color: this.color,
      metalness: 1.0,
      roughness: 1.0,
    });
    extendShaderWithWorldGradient(material, 0);
    this.stairsGroup.children.forEach((child) => {
      (child as Mesh).material = material;
    });
  }

  resize(
    poolLength: number,
    poolWidth: number,
    poolDepth: number,
    scene: Scene,
    fixedWidth?: boolean,
    fixedWidthValue?: number
  ) {
    // Remove the old stairs from the scene
    scene.remove(this.stairsGroup);

    // Update the pool dimensions
    this.poolLength = poolLength;
    this.poolWidth = poolWidth;
    this.poolDepth = poolDepth;

    if (this.isInEditMode) return;

    this.stairsGroup = new Group();
    if (fixedWidth != null) this.fixedWidth = fixedWidth;

    // Recreate the stairs with new dimensions
    this.createStairs();
    this.updateColor();

    // Add the stairs back to the scene
    scene.add(this.stairsGroup);
  }

  setAllStairsProperties(fullWidth: boolean, angular: boolean, scene: Scene) {
    this.isAngularStairs = angular;
    this.resize(
      this.poolLength,
      this.poolWidth,
      this.poolDepth,
      scene,
      fullWidth
    );
  }

  setUseFloatingStairs(floating: boolean, scene: Scene) {
    this.isSuspensionStairs = floating;
    this.resize(this.poolLength, this.poolWidth, this.poolDepth, scene);
  }

  setUseAngularStairs(angular: boolean, scene: Scene) {
    this.isAngularStairs = angular;
    this.resize(this.poolLength, this.poolWidth, this.poolDepth, scene);
  }

  setEditMode(isEditMode: boolean, scene: Scene) {
    this.isInEditMode = isEditMode;

    if (isEditMode) {
      this.resize(this.poolLength, this.poolWidth, this.poolDepth, scene);
    } else {
      this.resize(this.poolLength, this.poolWidth, this.poolDepth, scene);
    }
  }
}

export default PoolStairs;
